import { useNavigate } from "react-router-dom";
import { AlertCircle, CheckCircle2 } from "lucide-react";

export const DashboardActionItems = ({ items, emptyMessage = "All caught up. Nothing needs your attention right now." }) => {
  const navigate = useNavigate();

  if (items.length === 0) {
    return (
      <div className="border border-soft-gray rounded-2xl p-6 flex items-center gap-3" data-testid="dashboard-action-items-empty">
        <CheckCircle2 className="w-5 h-5 text-stranger-orange" />
        <p className="font-bold text-sm">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="border border-soft-gray rounded-2xl divide-y divide-soft-gray" data-testid="dashboard-action-items-list">
      {items.map((item, i) => (
        <button
          key={i}
          onClick={() => navigate(item.link)}
          data-testid={`dashboard-action-item-${i}`}
          className="w-full flex items-center gap-3 p-4 text-left hover:bg-warm-white transition-colors"
        >
          <AlertCircle className="w-4 h-4 text-stranger-orange shrink-0" />
          <span className="text-sm font-bold flex-1">{item.label}</span>
        </button>
      ))}
    </div>
  );
};
